'use client'


import Policy from './component/Policy'

const PrivacyPolicy = () => {
	return (
		<>
			<Policy />
		</>
	)
}

export default PrivacyPolicy
